import { render, staticRenderFns } from "./WarnWorkOccurVideo.vue?vue&type=template&id=babbe388&"
import script from "./WarnWorkOccurVideo.vue?vue&type=script&lang=js&"
export * from "./WarnWorkOccurVideo.vue?vue&type=script&lang=js&"
import style0 from "./WarnWorkOccurVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('babbe388')) {
      api.createRecord('babbe388', component.options)
    } else {
      api.reload('babbe388', component.options)
    }
    module.hot.accept("./WarnWorkOccurVideo.vue?vue&type=template&id=babbe388&", function () {
      api.rerender('babbe388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/WarnWorkOccurVideo.vue"
export default component.exports